import { useEffect, useState } from "react";

import { Menu } from "antd";

import { menusInit, pushSiderData, siderDataInit } from "./sider.config";
import { ROLES } from "../type/roles";
import { useLocation } from "react-router-dom";

const SiderCustom = () => {
  const [menus, setMenus] = useState(menusInit);
  const [items, setItems] = useState(siderDataInit);

  const hasPermission = (listRoleOfFunction) => {
    const listRoleOfUser = localStorage.getItem("roles");

    const isPermissed =
      listRoleOfFunction?.findIndex((role) => listRoleOfUser?.includes(role)) >
        -1 || listRoleOfUser?.includes(ROLES.ROLE_ADMIN);
    console.log("🚀 ~ hasPermission ~ isPermissed:", isPermissed);

    return isPermissed;
  };

  useEffect(() => {
    const setRolesMenu = () => {
      const roleMenus = menus
        .filter((e) => hasPermission(e.roles))
        .map((menu) => {
          if (menu?.subItems?.length > 0) {
            return {
              ...menu,
              subItems: menu.subItems.filter((subItem) =>
                hasPermission(subItem?.roles),
              ),
            };
          } else {
            return menu;
          }
        });

      setMenus([...roleMenus]);
    };
    setRolesMenu();
  }, []);

  useEffect(() => {
    const siderData = [];
    pushSiderData(menus, siderData);
    setItems([...siderData]);
  }, [menus]);
  const [keySider, setKeySider] = useState("1");
  const onClick = (e) => {
    setKeySider(e.key);
  };
  const location = useLocation();
  useEffect(() => {
    const current = items.find((item) => {
      const link = item?.label?.props?.to;
      return link === location.pathname;
    });
    if (current) setKeySider(current.key);
  }, [location.pathname, items]);
  return (
    <Menu
      theme="dark"
      mode="inline"
      inlineIndent={10}
      items={items}
      selectedKeys={[keySider]}
      defaultSelectedKeys={["1"]}
      onClick={onClick}
    />
  );
};

export default SiderCustom;
